import * as React from 'react';

function SvgEye(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 14.666a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z" }),
        React.createElement("path", { fill: "currentColor", d: "M21.786 11.274c-1.103-1.705-2.533-3.153-4.137-4.189-1.773-1.147-3.732-1.753-5.663-1.753-1.772 0-3.514.506-5.178 1.505-1.697 1.018-3.235 2.505-4.57 4.42a1.33 1.33 0 00-.027 1.48c1.1 1.723 2.517 3.173 4.095 4.194 1.778 1.152 3.69 1.735 5.68 1.735 1.947 0 3.91-.601 5.676-1.738 1.602-1.032 3.03-2.486 4.128-4.206a1.342 1.342 0 00-.004-1.448zM12 15.999a4 4 0 110-8.001 4 4 0 010 8.001z" })));
}

export default SvgEye;
